import { useTranslation } from 'react-i18next';
import {
  SectionTitle,
  ServicesSubItems,
} from '../services-menu/services-menu.styles';
import { ReactComponent as MeestShoppingLogo } from '../../../assets/meest-products/meest-shopping-logo.svg';
import { ReactComponent as FullScreenIcon } from '../../../assets/full-screen-icon.svg';
import { CrossSaleMenuSectionContainer } from './styles';
import { useStore } from '../../../stores/store';
import { Modals } from '../../../constants/modals';

const CrossSaleMenuSection = () => {
  const {
    modalStore: { open, close },
  } = useStore();
  const { t } = useTranslation();

  const openModalHandler = () => {
    open({
      id: Modals.CROSS_SALE,
      name: Modals.CROSS_SALE,
      props: {
        onClose: () => {
          close(Modals.CROSS_SALE);
        },
      },
    });
  };

  return (
    <CrossSaleMenuSectionContainer key='cross-sale'>
      <SectionTitle>{t('cross_sale_other_products')}</SectionTitle>
      <ServicesSubItems onClick={() => openModalHandler()}>
        <div className='topPart'>
          <span className='logo'>
            <MeestShoppingLogo />
          </span>
          <p className='productTitle'>Meest Shopping</p>
          <span className='newPill'>{t('new')}</span>
          <span className='fullScreenIcon'>
            <FullScreenIcon />
          </span>
        </div>
        <div className='bottomPart'>
          <span>{t('cross_sale_shop_online_with_discounts')}</span>
        </div>
      </ServicesSubItems>
    </CrossSaleMenuSectionContainer>
  );
};

export default CrossSaleMenuSection;
